import { render } from "./ProfileDashboard.vue?vue&type=template&id=3c82f6f9&scoped=true"
import script from "./ProfileDashboard.vue?vue&type=script&lang=js"
export * from "./ProfileDashboard.vue?vue&type=script&lang=js"

import "./ProfileDashboard.vue?vue&type=style&index=0&id=3c82f6f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c82f6f9"]])

export default __exports__